import {
  EXAM_PACKET_FINISHED,
  EXAM_PACKET_NOT_STARTED_YET,
  EXAM_PACKET_STARTED,
  EXAM_READY,
  EXAM_STATUS_DONE,
  EXAM_STATUS_NOT_ACTIVE,
  EXAM_STATUS_ACTIVE,
  EXAM_STATUS_WRONG_DATE,
  EXAM_STATUS_DOING,
} from 'constant';

export function getAlphabetByIndex(index) {
  switch (index) {
    case 0:
      return 'A';
    case 1:
      return 'B';
    case 2:
      return 'C';
    case 3:
      return 'D';
    case 4:
      return 'E';
    default:
      return null;
  }
}

export function getNumberByIndex(index) {
  switch (index) {
    case 0:
      return '(1)';
    case 1:
      return '(2)';
    case 2:
      return '(3)';
    case 3:
      return '(4)';
    case 4:
      return '(5)';
    default:
      return null;
  }
}

export function getIndexByAlphabet(alphabet) {
  switch (alphabet) {
    case 'A':
      return 0;
    case 'B':
      return 1;
    case 'C':
      return 2;
    case 'D':
      return 3;
    case 'E':
      return 4;
    default:
      return -1;
  }
}

export function getPercentage(exam) {
  let percentage = 0;

  const isExamStarted = EXAM_PACKET_STARTED === exam.paket_ujian.sta;
  const isExamFinished = exam.paket_ujian.sta === EXAM_PACKET_FINISHED;

  if (isExamStarted || isExamFinished) {
    const answers = exam.paket_ujian.jwb;

    if (Array.isArray(answers)) {
      percentage = Math.floor(
        (answers.filter((answer) => answer !== ' ').length / answers.length) *
          100
      );
    }
  }

  return percentage;
}

export function getCurrentDate() {
  const currentDate = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'Asia/Jakarta' })
  );
  currentDate.setHours(0, 0, 0, 0);

  return currentDate;
}

export function getExamDate(exam) {
  const examDate = new Date(
    new Date(exam.ujian.tgl).toLocaleString('en-US', {
      timeZone: 'Asia/Jakarta',
    })
  );
  examDate.setHours(0, 0, 0, 0);

  return examDate;
}

export function getStatus(exam) {
  let status = EXAM_STATUS_NOT_ACTIVE;

  const isSameDate = true;
  // const isSameDate = getCurrentDate().getTime() === getExamDate(exam).getTime();
  // const isCurrentDateGreater =
  //   getCurrentDate().getTime() > getExamDate(exam).getTime();
  const isExamReady = exam.ujian.sta === EXAM_READY;
  const isDoing = exam.paket_ujian.strt != null;
  const isExamPacketStarted = EXAM_PACKET_STARTED === exam.paket_ujian.sta;

  if (
    exam.paket_ujian.sta === EXAM_PACKET_FINISHED ||
    (isExamPacketStarted && !isExamReady)
  ) {
    status = EXAM_STATUS_DONE;
  } else if (isSameDate && isExamReady && isDoing) {
    status = EXAM_STATUS_DOING;
  } else if (isSameDate && isExamReady && isExamPacketStarted) {
    status = EXAM_STATUS_ACTIVE;
  } else if (!isSameDate && exam.paket_ujian.sta !== EXAM_PACKET_FINISHED) {
    status = EXAM_STATUS_WRONG_DATE;
  }

  return status;
}

export function getRemainingTime(exam) {
  const isExamPacketNotStartedYet =
    exam.paket_ujian.sta === EXAM_PACKET_NOT_STARTED_YET;

  const isSameDate = getCurrentDate().getTime() === getExamDate(exam).getTime();
  const isExamReady = exam.ujian.sta === EXAM_READY;

  if (isSameDate && isExamReady && isExamPacketNotStartedYet)
    return exam.ujian.drs;

  if (
    exam.paket_ujian.sta === 2 &&
    typeof exam.paket_ujian.ssw2 !== 'undefined'
  ) {
    return exam.paket_ujian.ssw2;
  }
  if (
    (exam.paket_ujian.sta === 3 || exam.paket_ujian.sta === 4) &&
    typeof exam.paket_ujian.ssw3 !== 'undefined'
  ) {
    return exam.paket_ujian.ssw3;
  }

  return exam.paket_ujian.ssw;
}

export function isImage(string) {
  return String(string).match(/\.(gif|jpe?g|tiff?|png|webp|bmp)$/i);
}
